import React from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import className from "classnames";

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const btn = "border border-gray-500 p-1.5 hover:bg-gray-200/10";

  const incrementDecrement = (item) => {
    if (item === "increment") {
      setCurrentPage((prev) => (prev < totalPages ? prev + 1 : totalPages));
    } else {
      setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));
    }
  };

  return (
    <div className="space-x-3">
      <button
        onClick={() => incrementDecrement("decrement")}
        className={`${btn}${className({
          "pointer-events-none opacity-40 cursor-not-allowed":
            currentPage === 1,
        })}`}>
        <MdOutlineKeyboardArrowLeft />
      </button>
      <button
        onClick={() => incrementDecrement("increment")}
        className={`${btn}${className({
          "pointer-events-none opacity-40 cursor-not-allowed":
            currentPage === totalPages,
        })}`}>
        <MdOutlineKeyboardArrowRight />
      </button>
    </div>
  );
};

export default Pagination;
